export const XTREMEPUSH_UPDATED_CUSTOMER_ID: 'xtremepush:customer_id:updated' =
  'xtremepush:customer_id:updated';

export const XTREMEPUSH_UPDATED_CUSTOMER_ID_WITH_ERROR: 'xtremepush:customer_id:updated_with_error' =
  'xtremepush:customer_id:updated_with_error';
